import { useState, useEffect, useRef } from 'react'


import { useTranslation } from 'src/utils/i18n'

import Grid from '@mui/material/Grid'
import Icon from 'src/@core/components/icon'
import styles from 'styles/browser-bookmark.module.scss'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import Card from '@mui/material/Card'
import Image from 'next/image'
import Link from 'next/link'
import dayjs from 'dayjs'

import { Pagination } from 'antd'

// request
import { useAndroidDevicePagedData } from 'src/hooks/useAndroidDevicePagedData'

import { useDispatch } from 'react-redux'

import { setCurrentTab } from 'src/store/apps/Common'
import ContentLoading from 'src/components/ContentLoading'

const BrowserBookmark = () => {
  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false

  const { t } = useTranslation('common')

  let Advanced = window.localStorage.getItem('Advanced')
  Advanced = Advanced == null || Advanced == 0 ? true : false
  const [initHistoryData, setInitHistoryData] = useState([])

  const [historyData, setHistoryData] = useState([])

  const [selectData, setSelectData] = useState({
    id: 1,
    category: 'SAFARI_HISTORY',
    name: 'Safari',
    icon: '/images/history/chrome.png',
    contents: []
  })

  const [active, setActive] = useState(null)

  const { context, data: bookmarkRecords, loading: isLoading, loadNext } = useAndroidDevicePagedData({
    source: 'cloud',
    category: 'CHROME_BOOKMARK',
    limit: 50
  })

  useEffect(() => {
    const contents = bookmarkRecords.map(item => ({
      ...item,
      time: dayjs.unix(item.visitTime + 978278400).format('D MMM ,hh:mm')
    }))
    const chromeData = {
      id: 2,
      category: 'CHROME_BOOKMARK',
      name: 'Chrome',
      icon: '/images/history/chrome.png',
      contents
    }
    setSelectData(chromeData)
    setInitHistoryData([chromeData])
    setHistoryData([chromeData])
  }, [bookmarkRecords])

  useEffect(() => {
    setActive(null)
  }, [context?.requestKey])

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100) loadNext()
  }, [loadNext, scroll])

  // 处理当前搜索
  const handleFilter = e => {
    let value = e.target.value
    if (value === '') {
      setHistoryData(initHistoryData)

      return
    }

    // 搜索过滤

    let filterData = initHistoryData.filter(item => {
      return item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    })

    setHistoryData(filterData)
  }

  // 处理当前选中数据
  const handleSelectClick = id => {
    setActive(id)

    let data = historyData.find(item => {
      return item.id === id
    })

    setSelectData(data)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setCurrentTab(t('Browser bookmark')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col relative'>
        <div className='w-full px-[10px] pt-[10px] pb-[15px] border-b border-[#E5E7EB]'>
          {historyData.map((row, index) => (
            <div
              key={index}
              className={`${active === row.id ? 'bg-[#E5E5E5]' : ''
                } w-full h-[48px] flex items-center px-[20px] rounded-[6px] cursor-pointer`}
              onClick={() => handleSelectClick(row.id)}
            >
              <Image src={row.icon} width={30} height={30} alt='img' />

              <span className='text-[14px] font-[600] text-[#334062] ml-[9px]'>{row.name}</span>
            </div>
          ))}
        </div>
        <div ref={dom} className='flex-1 p-[20px] overflow-auto'>
          {selectData.contents.map((row, index) => (
            <div key={index} className='w-full flex items-start mb-[8px]'>
              <Image className='mt-[2px]' src='/images/history/chrome.png' width={16} height={16} alt='safari' />
              <div className='text-[13px] ml-[9px] w-[calc(100%-25px)]'>
                <div className='text-[#222] overflow-hidden text-nowrap text-ellipsis'>{row.title}</div>
                <Link className='w-full]' href={row.url}>
                  <div className='w-full text-[#646464] overflow-hidden text-nowrap text-ellipsis'>{row.url}</div>
                </Link>
              </div>
            </div>
          ))}
        </div>
        {isLoading ? (
          <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
            <ContentLoading />
          </div>
        ) : null}
        {(historyData.length > 0 || isLoading) ||
          <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    </>
  )
}

export default BrowserBookmark


